import angular from 'angular'

function NominasCfdiEmpresas($http) {
  let schema = {
    id: 'number',
  };

  this.get = function () {
    return $http.get('/api/nominas/cfdi/empresas', {
      schema: schema,
    });
  };
}

angular.module('nominas.cfdi')
  .service('NominasCfdiEmpresas', NominasCfdiEmpresas);



// WEBPACK FOOTER //
// ./src/nominas/cfdi/services/NominasCfdiEmpresas.js